import * as React from "react";
import "./ImageViewerWithBlur.scss";
import ImageView from "../ImageView/ImageView";

export default function ImageViewerWithBlur({ url, id }: any) {
  return (
    <div className="blurImgcontainer">
      <img
        className="backgroundBlurImgcontainer"
        key={`${id}blurimage`}
        alt="bgblurImgcontainer"
        src={url}
      />

      <div className="foregroundImgcontainer">
        {url && <ImageView src={url} />}
      </div>
    </div>
  );
}
